import React from 'react';
import { Decision } from '../../../entity/entity.types';
import { fetchDecisions } from '../../lawyer.api';
import { LawyerNotifyError } from './LawyerNotifyError';
import { EntityTopDecisions } from '../../../entity/top-decisions/EntityTopDecisions';
import { LawyerContextType } from '../lawyer.types';
import { withLawyer } from '../LawyerContext';

type Props = {
  dontShowHref: boolean;
} & LawyerContextType;

type State = {
  decisions: Array<Decision>;
};

export class RawLawyerTopDecisions extends React.Component<Props, State> {
  state: State = {
    decisions: [],
  };

  id = 'lawyer-last-decisions';

  async componentDidMount() {
    const {
      lawyerInfos: { lawyerId },
    } = this.props;
    const decisions = (await fetchDecisions(lawyerId)).data.arrets;
    this.setState({ decisions });
    if (decisions.length > 0) {
      window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
    }
  }

  render() {
    const {
      allDecisionsLink,
      experience: { decisionCount },
      lawyerInfos,
      lawyerIsCurrentUser,
      dontShowHref,
      lawyerName,
    } = this.props;
    const { decisions } = this.state;

    if (decisions.length === 0) {
      return null;
    }

    return (
      <div id={this.id}>
        <EntityTopDecisions
          decisions={decisions}
          entityType="lawyer"
          allDecisionLink={allDecisionsLink}
          sources={{
            allDecisionsLink: 'read_all_lawyer_decisions_from_top_decisions',
            decisionLink: 'lawyer_top_decision',
          }}
          dontShowHref={dontShowHref}
          decisionCount={decisionCount}
          entityName={lawyerName}
        />
        <LawyerNotifyError
          lawyerInfos={lawyerInfos}
          lawyerIsCurrentUser={lawyerIsCurrentUser}
          lawyerName={lawyerName}
        />
      </div>
    );
  }
}

export const LawyerTopDecisions = withLawyer(RawLawyerTopDecisions);
